import ModalEditStockProduct from './ModalEditStockProduct'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, EditRow, ShowRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { CustomRenderStock } from '../../../../Stock/customRenderStock'
import { StockParentExtendedTy } from '../../../../Stock/types'
import ModalCreateStockProduct from './ModalCreateStockProduct'
import { ProductExtendedTyShort } from '../../../types'
import ModalCheckProductStock from '../../../../Stock/ModalCheckProductStock'

interface StockPRoductProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
}

const StockProduct: React.FC<StockPRoductProps> = ({ basicData, userPermissions }) => {

    const { t } = useTwinTranslation()

    const pageData = {
        title: t('stock', 'Inventario'),
        newText: t('addWarehouse', 'Añadir almacén')
    }

    return (
        <BaseScreenTableInner TableComponent={TableStockProduct} CreateModalComponent={ModalCreateStockProduct} EditModalComponent={ModalEditStockProduct} DeleteModalComponent={ModalCheckProductStock} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ 'StockParent.ProductId': basicData?.id }} basicData={basicData} />
    )
}

type TableStockProductProps = TableComponentBaseScreenInnerProps

const TableStockProduct: React.FC<TableStockProductProps> = ({ setOpened, setTableInstance, extraWhereParams }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<StockParentExtendedTy> = [
        {
            id: 'WarehouseId',
            dataKey: 'WarehouseId',
            label: t('warehouse', 'Almacén'),
            minWidth: 130,
            searchKey: 'Warehouse.name',
            sortable: true,
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Warehouse?.name} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('warehouse', 'Almacén') }
            },
        },
        {
            id: 'stock',
            dataKey: 'stock',
            label: t('units', 'Unidades'),
            customRender: (parameterValue, allRowData) => <CustomRenderStock allRowData={allRowData} />,
        },
        {
            id: 'location',
            dataKey: 'location',
            label: t('location', 'Localización'),
        },
        {
            id: 'minimum',
            dataKey: 'minimum',
            label: t('minimum', 'Mínimo'),
        },
        {
            id: 'optimum',
            dataKey: 'optimum',
            label: t('optimum', 'Óptimo'),
        },
        {
            id: 'edit',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(v, allRowData, e) => {
                e.stopPropagation()
                e.preventDefault()
                setOpened({
                    type: 'edit',
                    allRowData: allRowData
                })
            }} />
        },
        {
            id: 'show',
            dataKey: 'WarehouseId',
            label: '',
            width: 50,
            simpleLabel: t('see', 'Ver'),
            customRender: (parameterValue, allRowData) => <ShowRow key={'show' + parameterValue} {...{ parameterValue, allRowData }} onClick={(e) => setOpened({
                type: 'delete',
                allRowData: allRowData
            })} />
        },
    ]
    return (
        <TwinTable columns={columns} name='productStock' getDataFrom='/api/app/product/stock/getAllStockParentsComplete'
            onRowClick={(_id, rowData) => setOpened({
                type: 'delete',
                allRowData: rowData
            })} setTableInstance={setTableInstance} defaultOrder={{ order: 'desc', defaultOrderField: 'ProductId' }} extraWhereParams={extraWhereParams} />
    )
}

export default StockProduct